import React from "react";
import AccessTab from "./AccessTab";
import AdvancedTab from "./AdvancedTab";
import EmailTab from "./EmailTab";
import InstructionsTab from "./InstructionsTab";
import KnowledgeTab from "./KnowledgeTab";
import ModelTab from "./ModelTab";
import ToolsTab from "./ToolsTab";
import ValidationTab from "./ValidationTab";

export default function AgentConfigTabContent({ activeTab, tabPropsById }) {
  if (activeTab === "instructions") {
    return <InstructionsTab {...tabPropsById.instructions} />;
  }
  if (activeTab === "model") return <ModelTab {...tabPropsById.model} />;
  if (activeTab === "tools") return <ToolsTab {...tabPropsById.tools} />;
  if (activeTab === "knowledge") {
    return <KnowledgeTab {...tabPropsById.knowledge} />;
  }
  if (activeTab === "publicChat") {
    return <AccessTab {...tabPropsById.publicChat} />;
  }
  if (activeTab === "email") return <EmailTab {...tabPropsById.email} />;
  if (activeTab === "validation") {
    return <ValidationTab {...tabPropsById.validation} />;
  }
  if (activeTab === "advanced") {
    return <AdvancedTab {...tabPropsById.advanced} />;
  }
  return null;
}
